import {
  IMentionAttachmentComment,
  IMentionAttachmentCommentData
} from '../comment';
import { IDepartmentData } from '../department';
import { IFormSectionFieldData, IFormTemplateData } from '../form-template';
import { IUser, IUserData } from '../user/user.types';

export interface IEmployeeFormFieldSubmissionData {
  id?: number;
  value: string;
  field: number | IFormSectionFieldData;
  option_submissions: IEmployeeFormFieldOptionSubmissionData[] | number[];
}

export interface IEmployeeFormSubmissionData {
  id?: number;
  form: IFormTemplateData | number;
  answers?: IEmployeeFormFieldSubmissionData[];
  state?: EmployeeFormSubmissionStateEnum;
  owner?: string;
  employee?: string;
  created_at?: string | Date;
  updated_at?: string | Date;
}

export interface IEmployeeFormFieldOptionSubmissionData {
  id?: number;
  option: number;
}

export interface IEmployeeFormSubmissionStateInfoData {
  display_name: string;
  color: string;
}

export interface IEmployeeFormSectionSubmissionData {
  id?: number;
  fields: IEmployeeFormFieldSubmissionData[];
}

export interface IEmployeeFormSubmissionChecklistData {
  id?: number;
  assignee: IUserData | number;
  todo_template: IEmployeeFormSubmissionChecklistToDoTemplateData;
  form_submission: number;
  description: string;
  state?: number;
  completed_at: null | string;
  completed_by: null | string;
}

export interface IFormSubmissionChecklistStateInfo {
  value: FormSubmissionChecklistStateEnum;
  text?: string;
  icon?: string;
  color?: string;
}

export interface IEmployeeFormSubmissionChecklistToDoTemplateData {
  id?: number;
  todo_text: string;
  todo_department: number | IDepartmentData;
}

export type IEmployeeFormSubmissionCommentData = IMentionAttachmentCommentData;

export interface IEmployeeFormSubmission extends IEmployeeFormSubmissionData {
  validate(): boolean;
  getStateInfo(): IEmployeeFormSubmissionStateInfoData;
}

export interface IEmployeeFormFieldSubmission
  extends IEmployeeFormFieldSubmissionData {
  validate(): boolean;
}

export interface IEmployeeFormFieldOptionSubmission
  extends IEmployeeFormFieldOptionSubmissionData {
  validate(): boolean;
}

export interface IEmployeeFormSubmissionChecklist
  extends IEmployeeFormSubmissionChecklistData {
  validate(): boolean;
  getChecklistStateInfo(): IFormSubmissionChecklistStateInfo;
}

export interface IEmployeeFormSubmissionChecklistToDoTemplate
  extends IEmployeeFormSubmissionChecklistToDoTemplateData {
  validate(): boolean;
}

export type IEmployeeFormSubmissionComment = IMentionAttachmentComment;

export interface IEmployeeFormSectionSubmissionFieldErrorData {
  errors: string[];
}

export interface IEmployeeFormSubmissionCommentFieldErrorData {
  text?: string[];
}
export interface IEmployeeFormSubmissionFieldErrorData {
  form: string[];
  answers?: IEmployeeFormFieldSubmissionDataFieldErrorData[];
  owner?: string[];
}

export interface IEmployeeFormFieldSubmissionDataFieldErrorData {
  value: string[];
  field: string[];
  option_submissions: IEmployeeFormFieldOptionSubmissionFieldErrorData[];
}

export interface IEmployeeFormFieldOptionSubmissionFieldErrorData {
  option: string[];
  non_field_errors?: string[];
}

export interface IEmployeeFormSubmissionFieldError
  extends IEmployeeFormSubmissionFieldErrorData {
  clearErrors(): void;
}

export interface IEmployeeFormFieldSubmissionDataFieldError
  extends IEmployeeFormFieldSubmissionDataFieldErrorData {
  clearErrors(): void;
}

export interface IEmployeeFormFieldOptionSubmissionFieldError
  extends IEmployeeFormFieldOptionSubmissionFieldErrorData {
  clearErrors(): void;
}

export interface IEmployeeFormSubmissionCommentFieldError
  extends IEmployeeFormSubmissionCommentFieldErrorData {
  clearErrors(): void;
}

export enum EmployeeFormSubmissionStateEnum {
  Draft,
  InReview,
  InProgress,
  Completed,
  Cancelled
}

export enum FormSubmissionChecklistStateEnum {
  InProgress,
  Completed,
  NotApplicable
}
